import React from 'react';

const DotNet = () => {
    return (
        <>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb_box text-center">
                                <h2 className="breadcrumb-title">.NET: Enterprise Backend Framework</h2>
                                <ul className="breadcrumb-list">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/technologies">Technologies</a></li>
                                    <li className="breadcrumb-item active">.NET</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-wrapper section-space--ptb_100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="content-area">
                                <div className="service-details-content">
                                    <h1>.NET: The Enterprise Backend Framework</h1>
                                    
                                    <p className="lead">.NET is a powerful, open-source framework by Microsoft for building high-performance web, desktop, and mobile applications. Offering excellent scalability, enterprise support, and exceptional performance, .NET powers mission-critical systems at Microsoft, Amazon, Stack Overflow, and Fortune 500 companies.</p>

                                    <h3 className="mt-50">Enterprise-Grade Performance</h3>
                                    <p>.NET consistently ranks among the fastest web frameworks in benchmarks. Its modern architecture, Just-In-Time compilation, and extensive optimization tools make it ideal for high-throughput, low-latency systems.</p>

                                    <h3 className="mt-40">Complete Feature Set</h3>
                                    <ul>
                                        <li><strong>Cross-Platform Support:</strong> Deploy to Windows, Linux, or macOS</li>
                                        <li><strong>High Performance:</strong> Consistently fastest among web frameworks</li>
                                        <li><strong>Strong Security:</strong> Built-in security features and compliance support</li>
                                        <li><strong>Entity Framework ORM:</strong> Powerful and flexible data access</li>
                                        <li><strong>Built-in Dependency Injection:</strong> Professional service management</li>
                                        <li><strong>Comprehensive Testing Framework:</strong> Built-in unit testing support</li>
                                        <li><strong>Microservices Ready:</strong> Designed for modern distributed systems</li>
                                        <li><strong>Cloud Integration:</strong> First-class Azure support</li>
                                    </ul>

                                    <h3 className="mt-40">Real-World Enterprise Applications</h3>
                                    <p><strong>Banking & Finance:</strong> High-performance transaction processing systems handling millions of transactions daily.</p>
                                    <p><strong>Healthcare Systems:</strong> Patient management, EHR systems, and medical imaging platforms.</p>
                                    <p><strong>Telecommunications:</strong> Network management and billing systems at massive scale.</p>

                                    <h3 className="mt-40">AppCore's .NET Expertise</h3>
                                    <div className="case-study-box mt-30">
                                        <h5>Case Study: Distributed Financial System</h5>
                                        <p>We architected a microservices-based financial platform using .NET:</p>
                                        <ul>
                                            <li>💰 Processing 100,000+ transactions/hour</li>
                                            <li>🔐 Enterprise-grade security & compliance</li>
                                            <li>📈 99.99% uptime SLA</li>
                                            <li>🌐 Multi-region deployment</li>
                                        </ul>
                                    </div>

                                    <h3 className="mt-40">Advanced Patterns We Implement</h3>
                                    <ul>
                                        <li>Microservices architecture with service mesh</li>
                                        <li>CQRS (Command Query Responsibility Segregation)</li>
                                        <li>Event sourcing for audit trails</li>
                                        <li>Advanced caching strategies</li>
                                        <li>Database optimization and sharding</li>
                                        <li>Async processing with message queues</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar-area">
                                <div className="sidebar-widget mb-50">
                                    <h5 className="widget-title mb-30">.NET Capabilities</h5>
                                    <ul className="sidebar-list">
                                        <li>🚀 Ultra-High Performance</li>
                                        <li>🔒 Enterprise Security</li>
                                        <li>📊 Advanced Data Access</li>
                                        <li>☁️ Cloud Native</li>
                                        <li>🏗️ Microservices Ready</li>
                                        <li>📱 Multi-Platform</li>
                                    </ul>
                                </div>

                                <div className="sidebar-widget">
                                    <h5 className="widget-title mb-30">.NET Performance</h5>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Throughput (req/sec)</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>500k+</p>
                                    </div>
                                    <div className="metric-item mb-20">
                                        <p className="metric-label">Response Time</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>&lt;50ms</p>
                                    </div>
                                    <div className="metric-item">
                                        <p className="metric-label">Uptime</p>
                                        <p className="metric-value" style={{color: '#64b1a6', fontSize: '24px', fontWeight: 'bold'}}>99.99%</p>
                                    </div>
                                </div>

                                <div className="sidebar-widget mt-50">
                                    <h5 className="widget-title mb-30">Industry Adoption</h5>
                                    <p className="small">Used by Microsoft, Amazon, Stack Overflow, Bandwidth, and thousands of Fortune 500 companies for mission-critical enterprise systems.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DotNet;
